<section
	class="containerFinancials"
	[ngClass]="{ 'col-md-9': !isMobile && showClientSearch }"
>
	<div class="search" [ngClass]="{ shadow: !isMobile }">
		<div class="search-header" *ngIf="showClientSearch">
			<h1>{{ 'PAGES.FINANCIALS.TITLE' | translate }}</h1>
		</div>
		<client-search
			*ngIf="showClientSearch"
			(selectedClient)="selectedClient($event)"
		>
		</client-search>
		<div class="search-field">
			<p-calendar
				[readonlyInput]="true"
				[(ngModel)]="periodDate[0]"
				(ngModelChange)="setPeriodLimits()"
				placeholder="{{ 'PAGES.FINANCIALS.SEARCH.MIN_DATE' | translate }}"
				[selectionMode]="'single'"
				styleClass="calendar-panel-financials"
				inputStyleClass="calendar-financials"
				dateFormat="dd/mm/yy"
				[monthNavigator]="true"
				yearRange="2000:2030"
				inputId="navigators"
				[yearNavigator]="true"
			>
			</p-calendar>
		</div>
		<div
			class="search-field"
			[pTooltip]="withDateLimit && ('TOOLTIPS.REPORTS.LIMIT' | translate)"
			tooltipPosition="top"
		>
			<p-calendar
				[readonlyInput]="true"
				[(ngModel)]="periodDate[1]"
				(ngModelChange)="setPeriodLimits()"
				placeholder="{{ 'PAGES.FINANCIALS.SEARCH.MAX_DATE' | translate }}"
				[selectionMode]="'single'"
				[maxDate]="maxPeriodDate"
				styleClass="calendar-panel-financials"
				inputStyleClass="calendar-financials"
				dateFormat="dd/mm/yy"
				[monthNavigator]="true"
				yearRange="2000:2030"
				inputId="navigators"
				[yearNavigator]="true"
			>
			</p-calendar>
		</div>
		<div
			class="search-buttons--container"
			[pTooltip]="!hasValidDates && ('TOOLTIPS.REPORTS.INVALID' | translate)"
			tooltipPosition="top"
		>
			<div class="search-button">
				<button
					class="btn btn-primary"
					[disabled]="isLoading || !hasValidDates"
					(click)="loadData()"
				>
					{{ 'GENERAL.FILTER' | translate }}
				</button>
			</div>
			<div class="search-button">
				<button
					class="btn btn-primary"
					[disabled]="isLoadingReport || !hasValidDates"
					(click)="exportReport()"
				>
					<img
						*ngIf="isLoadingReport"
						src="/assets/images/preloaders/global_preloader.gif"
					/>
					<span *ngIf="!isLoadingReport">{{
						'GENERAL.EXPORT_FINANCE_REPORT' | translate
					}}</span>
				</button>
			</div>
		</div>
	</div>
	<!-- List financials -->
	<p-table
		selectionMode="simple"
		dataKey="id"
		[value]="stats"
		[totalRecords]="total"
		[showLoader]="true"
		[loading]="isLoading"
		[lazy]="true"
		[metaKeySelection]="false"
		[rows]="limit"
		[paginator]="true"
		[alwaysShowPaginator]="true"
		[showCurrentPageReport]="true"
		[currentPageReportTemplate]="paginatorTemplate"
		[pageLinks]="5"
		(onLazyLoad)="loadData($event)"
	>
		<ng-template pTemplate="header">
			<tr>
				<th>{{ 'PAGES.FINANCIALS.HEADER_DATE' | translate }}</th>
				<th>{{ 'PAGES.FINANCIALS.HEADER_CLIENT' | translate }}</th>
				<th>{{ 'PAGES.FINANCIALS.HEADER_REASONS' | translate }}</th>
				<th *ngIf="!isProfessionalZen">
					{{ 'PAGES.FINANCIALS.HEADER_REVENUE' | translate }}
				</th>
			</tr>
		</ng-template>
		<ng-template pTemplate="body" let-rowData>
			<tr [pSelectableRow]="rowData" (click)="showEventDetails(rowData.id)">
				<td>{{ rowData.day | date: 'dd/MM/yyyy - HH:mm' }}</td>
				<td>{{ rowData.userName }}</td>
				<td>
					<span class="reasons" *ngFor="let res of rowData.contactReason">
						{{ res }}
					</span>
				</td>
				<td *ngIf="!isProfessionalZen">
					{{
						(getFinalCompensation(rowData) !== false
							? rowData.compensationFinal.compensation
							: rowData.professionalCompensation
						) | currency: rowData.currency:'symbol'
					}}
				</td>
			</tr>
		</ng-template>
		<ng-template pTemplate="paginatorright">
			<span *ngIf="!isProfessionalZen"
				>{{ 'GENERAL.TOTAL' | translate }}:
				{{ totalRevenue | currency: userPref.Currency:'symbol' }}</span
			>
		</ng-template>
	</p-table>
</section>
